// src/access.ts
import { IUser } from '@/service/user';

export default function (initialState: { user: IUser }) {
  return {
    isAdmin: initialState?.user?.role === 'admin', // 管理员
    isInternal: initialState?.user?.isInternal, // 是否内部用户
  };
}
